var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19424 0.986453L11.5942 6.38645L10.1942 7.78645L6.19424 3.78645L2.19424 7.78645L0.794238 6.38645L6.19424 0.986453Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSelectIcon);
export default __webpack_public_path__ + "static/media/closeSelectIcon.0863da75fe338df6b958be9f50c13552.svg";
export { ForwardRef as ReactComponent };